module.exports = "https://r.zoocdn.com/_next/static/images/favicon-16x16-688e0971744b4769a92a8f2ee69b780d.png";